import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import "./AboutConference.css"

function AboutConference() {
    return (
        <>
            <Row>
                <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                    <Card className="aboutCard">
                        <Card.Header className="aboutCardHeader">Organizator</Card.Header>
                        <Card.Body className="aboutCardBody">
                            <img 
                                src={`${process.env.PUBLIC_URL}/images/logo-01-512x192.png`} 
                                alt="Polskie Stowarzyszenie Rodzin z Atrezją Przełyku" 
                                width="100%"
                                height="100%"
                                style={{
                                    objectFit: 'contain',
                                    objectPosition: 'center',
                                    margin: '0 auto'
                                }}
                            />
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                    <Card className="aboutCard">
                        <Card.Header className="aboutCardHeader">Data Konferencji</Card.Header>
                        <Card.Body className="aboutCardBody">
                            <h1><i className="bi bi-calendar3"></i></h1>
                            <b>9 maja 2026 r.</b>
                            <br />
                            sobota
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                    <Card className="aboutCard">
                        <Card.Header className="aboutCardHeader">Miejsce Konferencji</Card.Header>
                        <Card.Body className="aboutCardBody">
                            Wrocławski Uniwersytet Medyczny, <br />
                            Wydział Farmacji<br />
                            <b>Sala Wykładowa W3</b><br /><br />
                            <i className="bi bi-geo-alt-fill"></i> <a href="https://maps.app.goo.gl/E3gduHHYiEHiPnQm7" target="_blank">ul. Borowska 211, 50-556 Wrocław</a><br />
                            Parking dostępny na terenie uczelni<br />
                            <b>UWAGA: Liczba darmowych miejsc jest ograniczona!</b><br /><br />
                            <iframe 
                                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d724.0436732353338!2d17.031272566585457!3d51.07625593517949!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470fc256e636cfef%3A0xa6f54ed03ed32efe!2sWydzia%C5%82%20Farmaceutyczny%20Uniwersytetu%20Medycznego%20im.%20Piast%C3%B3w%20%C5%9Al%C4%85skich%20we%20Wroc%C5%82awiu!5e0!3m2!1spl!2sus!4v1771018470629!5m2!1spl!2sus" 
                                width="100%" 
                                height="250" 
                                style={{ border: 0 }} 
                                allowFullScreen 
                                loading="lazy" 
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Mapa konferencji"
                            ></iframe>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
}

export default AboutConference